import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export default function HowItWorks() {
  const steps = [
    { n: "01", title: "Download Zumroo App", desc: "Free install from the Play Store. Set up your broker profile in under 2 minutes." },
    { n: "02", title: "Browse Verified Listings", desc: "Filter by city, locality, BHK and price. See only real owner properties." },
    { n: "03", title: "Pay & Unlock Owner Contact", desc: "Tap unlock, pay ₹49 or ₹79, and call the owner directly. That's it." },
  ];

  return (
    <section id="how" className="section bg-white border-y border-[#E4E1D9]">
      <div className="container-z">
        <div className="max-w-2xl">
          <div className="label-mono mb-3">How it works</div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#1A231E]">
            Three steps to your <span className="text-[#C86646]">next deal</span>.
          </h2>
        </div>

        <div className="mt-10 sm:mt-14 grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6 relative">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              className="zcard p-7 relative"
              data-testid={`step-card-${i}`}
            >
              <div className="font-display text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-br from-[#C86646] to-[#1E3F33]">
                {s.n}
              </div>
              <h3 className="mt-3 text-lg font-bold text-[#1A231E]">{s.title}</h3>
              <p className="mt-2 text-sm text-[#5C6B62] leading-relaxed">{s.desc}</p>
              {i < steps.length - 1 && (
                <div className="hidden md:flex absolute top-1/2 -right-3 w-6 h-6 -translate-y-1/2 items-center justify-center rounded-full bg-white border border-[#E4E1D9] z-10">
                  <ArrowRight className="w-3 h-3 text-[#5C6B62]" />
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
